














import { computed, defineComponent, PropType } from '@vue/composition-api';
import { VueConstructor } from 'vue';
import { InputFacade } from 'vue-input-facade';
import { FOCUSABLE_ERROR_INPUT_CLASS } from './form';

export default defineComponent({
	props: {
		hasError: Boolean,
		// eslint-disable-next-line vue/require-prop-types
		value: {
			default: '',
		},
		tag: {
			type: String as PropType<null | string | VueConstructor>,
			default: undefined,
		},
	},
	setup(props) {
		const is = computed(() => (props.tag ? props.tag : InputFacade));
		return {
			is,
			FOCUSABLE_ERROR_INPUT_CLASS,
		};
	},
});
